import React, { useState, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import SelectionListCard from '@wix/da-ds/pkg/SelectionList/SelectionListCard';
import SelectionListItem from '@wix/da-ds/pkg/SelectionList/SelectionListItem';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import IconButtonWithBackground from '@wix/da-ds/pkg/Buttons/IconButton/IconButtonWithBackground';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { DeviationResourceType } from '../../types/deviation';
import { useOnOutsideClick } from '../../utils/hooks/useOnOutsideClick';
import DesktopShareModal from '../../SharePopup/DesktopSharePopup/DesktopShareModal';
import TierCreatorReduxModule from '../redux/creator/ModuleLoadable';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import s from './MoreActionsButton.scss';
var MoreActionsButton = function (_a) {
    var isOwner = _a.isOwner, deviation = _a.deviation, className = _a.className, editTier = _a.editTier, deleteTier = _a.deleteTier, unsubscribe = _a.unsubscribe;
    var isMobile = useContext(MobileContext);
    var _b = useState(false), isMenuShown = _b[0], setIsMenuShown = _b[1];
    var _c = useState(false), isShareModalShown = _c[0], setIsShareModalShown = _c[1];
    var isUserSubscribed = useSubscriptionTier(deviation).isUserSubscribed;
    var showShareModal = function () { return setIsShareModalShown(true); };
    var hideShareModal = function () { return setIsShareModalShown(false); };
    var t = useTranslation().t;
    var rootRef = useRef(null);
    useOnOutsideClick([rootRef], function () { return setIsMenuShown(false); });
    var toggleMenuVisibility = function () { return setIsMenuShown(!isMenuShown); };
    var renderGoToTierMenuItem = function () { return (React.createElement(SelectionListItem, { label: t('deviationview.tierCard.moreActionsMenu.item.goToTierPage'), onClick: function () {
            window.location.href = deviation.url;
        } })); };
    var renderOwnerMenuItems = function () { return (React.createElement(React.Fragment, null,
        renderGoToTierMenuItem(),
        !isMobile && (React.createElement(SelectionListItem, { label: t('common.edit'), onClick: editTier, biData: {
                evid: BiEventType.TIER_EDIT_CLICK,
                typeid: DeviationResourceType.TIER,
                itemid: deviation.deviationId,
            } })),
        React.createElement(SelectionListItem, { label: t('common.delete'), onClick: deleteTier, biData: {
                evid: BiEventType.TIER_DELETE,
                typeid: DeviationResourceType.TIER,
                itemid: deviation.deviationId,
            } }),
        React.createElement(TierCreatorReduxModule, null))); };
    var renderVisitorMenuItems = function () { return (React.createElement(React.Fragment, null,
        renderGoToTierMenuItem(),
        React.createElement(SelectionListItem, { label: t('common.share'), onClick: showShareModal, biData: {
                evid: BiEventType.CLICK_SHARE,
                typeid: DeviationResourceType.TIER,
                itemid: deviation.deviationId,
            } }),
        isUserSubscribed && (React.createElement(SelectionListItem, { label: t('deviationview.tierCard.moreActionsMenu.item.unsubscribe'), onClick: unsubscribe })))); };
    return (React.createElement("div", { className: c(s['root'], className), ref: rootRef },
        React.createElement(IconButtonWithBackground, { icon: EllipsisIcon, size: IconSize.MEDIUM, onClick: toggleMenuVisibility }),
        isMenuShown && (React.createElement(SelectionListCard, { className: s['menu'] }, isOwner ? renderOwnerMenuItems() : renderVisitorMenuItems())),
        isShareModalShown && (React.createElement(DesktopShareModal, { deviation: deviation, onRequestClose: hideShareModal }))));
};
MoreActionsButton.displayName = 'MoreActionsButton';
export default MoreActionsButton;
//# sourceMappingURL=MoreActionsButton.js.map